import { gql } from '@moonpig/web-core-graphql'
import { ProductSearchFieldsFragment } from './productFragment'

export const ProductSearchGQL = gql`
  query SearchServiceProductSearch(
    $searchTerm: String!
    $limit: Int!
    $offset: Int!
    $filters: CriteriaInput!
    $department: [DepartmentsEnum!]
    $returnSuggestions: Boolean!
    $experimentValues: String
    $platform: Platform
    $nbaAlgorithm: String
    $sortOrder: SortOrder
    $sponsoredProducts: [SponsoredProductInput!]
    $isInitialQuery: Boolean!
    $useSmartDepartmentRedirection: Boolean!
  ) {
    productSearch(
      searchTerm: $searchTerm
      department: $department
      limit: $limit
      offset: $offset
      filters: $filters
      experimentValues: $experimentValues
      platform: $platform
      nbaAlgorithm: $nbaAlgorithm
      sortOrder: $sortOrder
      sponsoredProducts: $sponsoredProducts
      isInitialQuery: $isInitialQuery
      useSmartDepartmentRedirection: $useSmartDepartmentRedirection
    ) {
      totalClickRankDocumentCount
      appliedIntents {
        intentId
        ordinal
        value
      }
      departmentCounts {
        ... on AlternativeSearchDepartmentCount {
          department
          count
          label
        }
      }
      count
      redirectedDepartment
      products {
        ...SearchServiceProduct
        ...SearchServiceProductDynamicImages
      }
      suggestions @include(if: $returnSuggestions) {
        ...SearchServiceProduct
        ...SearchServiceProductDynamicImages
      }
      spellingCorrection {
        initialSearchTerm
        correctedSearchTerm
      }
      supportedSortOrders {
        displayText
        isDefault
        value
      }
      isMultiBuySupported
    }
  }
  ${ProductSearchFieldsFragment}
`
